export default __webpack_public_path__ + "static/media/icon-space.83aa1272.svg";